import { Pipe, PipeTransform } from '@angular/core';


function addLeadZero(num) {
  const isNegative = num < 0;
  return (isNegative ? '-' : '') + ('000' + Math.abs(num)).slice(-2);
}
@Pipe({
  name: 'timeLabelFromMinutes'
})
export class TimeLabelFromMinutesPipe implements PipeTransform {

  transform(value: number | null): string {
    if (value === 0) {
      return '00:00';
    }
    if (value) {
      const hours = addLeadZero( (value < 0 ? -1 : 1) * Math.floor(Math.abs(value) / 60));
      const minutes = addLeadZero(Math.abs((value % 60)));
      return `${hours}:${minutes}`;
    }
    return '';
  }
}
